<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<form name="ActionForm" class="form-horizontal" role="form" novalidate>
					<!--START OPTIONS-->
					<!--School (For getting logo)-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">School (For Selecting Logo)</label>
						<div class="col-sm-4 col-lg-3">
							<!-- <select class="form-control" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="report.SchoolID">
                                <option value="" style="display:none;"></option>
                                <option *ngFor="let o of schoolList" [ngValue]="o.SchoolID">{{o.SchoolName}}</option>
                            </select> -->

							<caass-schoolselector [ShowAll]="false" [IsReport]="true" [ReportID]="395"> </caass-schoolselector>
						</div>
					</div>

					<!--SchoolGroupID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">School Group</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="SchoolGroupID" [(ngModel)]="report.SchoolGroupID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of SchoolGroupList" [ngValue]="o.SchoolGroupID">
									{{ o.SchoolGroupDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--StartDate-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Start Date</label>
						<div class="col-sm-4 col-lg-3">
							<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="report.StartDate" name="txtStartDate"></p-calendar>
						</div>
					</div>

					<!--EndDate-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">End Date</label>
						<div class="col-sm-4 col-lg-3">
							<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="report.EndDate" name="txtEndDate"></p-calendar>
						</div>
					</div>

					<!--Period-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Period</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="PeriodID" [(ngModel)]="report.PeriodID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of PeriodList" [ngValue]="o.PeriodID">
									{{ o.PeriodName }}
								</option>
							</select>
						</div>
					</div>

					<!--SchoolVisitStatus-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">School Visit Status</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="SchoolVisitStatusID" [(ngModel)]="report.SchoolVisitStatusID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of SchoolVisitStatusList" [ngValue]="o.SchoolVisitStatusID">
									{{ o.SchoolVisitStatusName }}
								</option>
							</select>
						</div>
					</div>

					<!--ShowContainer-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Show Container</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="ShowContainerID" [(ngModel)]="report.ShowContainerID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of ShowContainerList" [ngValue]="o.ShowContainerID">
									{{ o.ShowContainerName }}
								</option>
							</select>
						</div>
					</div>

					<!--OrderBy-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Sort By</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="OrderByID" [(ngModel)]="report.OrderByID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of OrderByList" [ngValue]="o.OrderByID">
									{{ o.OrderByName }}
								</option>
							</select>
						</div>
					</div>

					<!--ImageLogo-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Logo</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="ImageLogo" [(ngModel)]="report.ImageLogo">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of ImageLogoList" [ngValue]="o.ImageLibraryID">
									{{ o.LogoDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--UserID-->

					<!--File Type-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Output File Type</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="OutputTypeID" [(ngModel)]="OutputTypeID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of OutputTypeList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--Submit Form-->
					<div class="hr-line-dashed"></div>
					<div class="form-group">
						<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
							{{ errorMessage }}
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label"></label>
						<div class="col-md-4 col-lg-3">
							<div name="Saveing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
							<button name="btnSaving" *ngIf="!isProcessing" class="btn btn-primary" type="button" (click)="Print()">Print</button>
							<button
								name="btnMerge"
								*ngIf="!isProcessing"
								class="btn btn-primary"
								style="margin-left: 5px"
								type="button"
								(click)="MergeToGroup()"
							>
								Merge to Group
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
